import React, { useEffect, useState } from "react";
import { Snackbar, Stack, Typography, CircularProgress } from "@mui/material";

interface ToastProps {
  toastOpen: boolean;
  handleToast: Function;
  toastTitle: string;
  toastSubtitle: string;
  toastType?: "loading" | "info" | "error" | "success";
  margin?: number;
}
const SuccessToast = ({
  toastOpen,
  handleToast,
  toastTitle,
  toastSubtitle,
  toastType,
  margin = 0,
}: ToastProps) => {
  return (
    <Snackbar
      open={toastOpen}
      autoHideDuration={toastType === "loading" || toastType === "success" ? null : 5000}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      onClose={() => handleToast(false)}
      style={{ zIndex: "99999999", textAlign: "center", width: "100%", marginTop: `${margin*70}px` }}
    >
      <Stack
        direction={"row"}
        gap={"1rem"}
        padding={"10px 40px 10px 10px"}
        alignItems={"center"}
        sx={{
          background: "#1E2121",
          borderRadius: "48px",
          boxShadow: "0px 2px 15px 0px rgba(0,0,0,0.25)",
          zIndex: "999999999",
          border: "1px solid #5a5f60",
          margin: "0 auto",
        }}
        style={{ zIndex: "99999999" }}
      >
        {toastType === "loading" && (
          <div style={{ width: "44px", height: "44px" }}>
            <CircularProgress color={"info"} size={44} />
          </div>
        )}
        {toastType === "info" && (
          <img src={"/icons/toast-info-icon.svg"} width={44} height={44} alt={""} />
        )}
        {toastType === "error" && (
          <img src={"/icons/toast-fail-icon.svg"} width={44} height={44} alt={""} />
        )}
        {toastType === "success" && (
          <img src={"/icons/success-tick.svg"} width={44} height={44} alt={""} />
        )}
        <Stack direction={"column"} gap={"4px"} alignItems={"flex-start"}>
          <Typography variant="body2" fontWeight={600} color={"#E2E3E3"}>
            {toastTitle}
          </Typography>
          <Typography variant="caption" color={"#B4B7B8"}>
            {toastSubtitle}
          </Typography>
        </Stack>
      </Stack>
    </Snackbar>
  );
};

export default SuccessToast;
